import type { C1_ModelSettingsData, C1_MasterPdfConfigData } from "../types/C1_ModelTypes";

/** Moves the legacy dimensions flag into floor-plan properties without replacing a saved document choice. */
export function migrateC1PdfSettings(settings: C1_ModelSettingsData, stored?: C1_MasterPdfConfigData) {
  const { showDimensionsInPdf, ...modelSettings } = (settings ?? {}) as C1_ModelSettingsData & { showDimensionsInPdf?: boolean };
  let pdfConfig = structuredClone(stored);
  if (typeof showDimensionsInPdf === "boolean") {
    pdfConfig ??= { chapters: [] };
    const floorPlans = pdfConfig.chapters.find(chapter => chapter.id === "floorPlans");
    if (floorPlans) floorPlans.includeDimensions ??= showDimensionsInPdf;
    else pdfConfig.chapters.push({ id: "floorPlans", enabled: true, planMode: "design", includeDimensions: showDimensionsInPdf });
  }
  return { modelSettings, pdfConfig };
}
